import orderBy from 'lodash/orderBy';
import React from 'react';
import { SeatStyle, SeatStyleCulture } from '../../classes/seat';
import LegendContent from './legend-content';
import { A11yDialog } from 'react-a11y-dialog';
import A11yDialogInstance from 'a11y-dialog';

interface ILegendProps {
    seatStyles: Array<SeatStyle>;
    seatStyleCultures: Array<SeatStyleCulture>;
    legendTitle: string;
    legendModalText: string;
    legendTitleAltText: string;
    selectedSeats: boolean;
    legendFlyOut: boolean;
    updateLegendFlyout: (updateFlyout: boolean) => void;
    isMobile: boolean;
}
interface ILegendState {
    firstTimeHidden: boolean; //used to keep track so we only close the legend once so if users want to use the legend on mobile, they can open it again
} 

class LegendModal extends React.PureComponent<ILegendProps, ILegendState>{
    constructor(props) {
        super(props);
        this.state = { firstTimeHidden: false };        
    }

    componentWillReceiveProps(nextProps: ILegendProps) {
        if (!this.state.firstTimeHidden && nextProps.isMobile && nextProps.selectedSeats) {
            if (this.props.legendFlyOut) {
                nextProps.updateLegendFlyout(false);
            }

            this.setState({ firstTimeHidden: true });
        }
    }


    render() {
        const modalClasses = {
            container: 'legend-container-modal open', overlay: 'legend-modal', dialog: 'legend-modal-inner', title: 'legend-modal-header', closeButton: 'legend-modal-close-icon'
        };

        if (this.props.legendFlyOut) {
            return (
                <>
                    <A11yDialog
                        id="legend_modal"
                    title={<h2>{this.props.legendTitle}</h2>}
                        dialogRef={instance => this.handleModalInstance(instance, this.props.updateLegendFlyout)}                        
                    classNames={modalClasses}
                    closeButtonContent={<svg className="legend-modal-close-icon"><use xlinkHref="#icon-close" /></svg>}
                        closeButtonLabel={'close'}
                    >                        
                        <LegendContent {...this.props} renderModal={true} />

                    </A11yDialog>
                    {this.getLegendButton()}
                </>
            )
        }
        else {
            return (this.getLegendButton())
        }
    }

    getLegendButton() {
        return (
            <button className="legend-container-modal" onClick={(evt) => { this.openLegendModal(); }}>
                <span className="visually-hidden">Open Legend</span>
                <div className="legend-trigger-modal" >
                    <div className="legend-default-modal-dots">
                        {
                            this.getLegendFilters()
                        }
                    </div>
                    <p>{this.props.legendTitle}</p>
                </div>
            </button>
        );
    }


    handleModalInstance(instance: A11yDialogInstance, updateLegendFlyout: (updateFlyout: boolean) => void) {
        instance?.show();
        instance?.on('hide', () => updateLegendFlyout(false));
    }

    openLegendModal() {
        this.props.updateLegendFlyout(true);
    }

    public getLegendFilters() {
        const culturesWithDisplayName = this.props.seatStyleCultures.filter(culture => culture.displayName != null);

        const visibleStyles = orderBy(this.props.seatStyles.filter(style => { return culturesWithDisplayName.some(culture => culture.seatStyleId === style.id) }),
            (style) => {
                return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
            });

        let legendFilters =
            orderBy(visibleStyles.filter(style => culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].showOnCollapsedLegend),
                (style) => {
                    return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
                }
            ).map(style => {
                return <div key={style.id} className="legend-default-modal-icon" style={{ backgroundColor: style.svgDefaultFill }}></div>;
            });

        if (legendFilters.length > 3) {
            legendFilters = legendFilters.filter((value, index) => index < 3);
        }
        return legendFilters;
    }
}

export default LegendModal;